import { instance } from "./instanceApi";

const API_PATH = "/auth";

/**
 * Logs a user in.
 * @param {Object} credentials The user's credentials ({email, password}).
 * @returns {Promise<Object>}
 */
export const login = (credentials) => {
  return instance.post(`${API_PATH}/login`, credentials);
};

/**
 * Registers a new user.
 * @param {Object} userData The user's data for registration.
 * @returns {Promise<Object>}
 */
export const signup = (userData) => {
  return instance.post(`${API_PATH}/signup`, userData);
};

/**
 * Checks if a user is logged in by checking for a token.
 * @returns {boolean}
 */
export const logged = () => {
  const token = localStorage.getItem("token");
  return !!token; // Returns true if token exists, false otherwise
};

/**
 * Logs the user out by removing their token and user info.
 */
export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};